import { ModuleSteps } from 'src/app/core/models/step.model';
import { StepState } from 'src/app/core/enums/enums';

export const VoluntaryChangeSteps = new ModuleSteps([
  {
    title: 'voluntary-change.steps.choose-option',
    state: StepState.Active
  },
  {
    title: 'voluntary-change.steps.docsa',
    state: StepState.Normal
  },
  {
    title: 'voluntary-change.steps.seat-map',
    state: StepState.Normal
  },
  {
    title: 'voluntary-change.steps.confirmation',
    state: StepState.Normal
  },
  { title: 'voluntary-change.steps.split', state: StepState.Normal },
  { title: 'voluntary-change.steps.final', state: StepState.Normal },
  { title: 'voluntary-change.steps.reissue', state: StepState.Normal }
]);

export const VoluntaryChangeStepsNotAirline = new ModuleSteps([
  {
    title: 'voluntary-change.steps.choose-option',
    state: StepState.Active
  },
  {
    title: 'voluntary-change.steps.docsa',
    state: StepState.Normal
  },
  {
    title: 'voluntary-change.steps.confirmation',
    state: StepState.Normal
  },
  { title: 'voluntary-change.steps.split', state: StepState.Normal },
  { title: 'voluntary-change.steps.final', state: StepState.Normal },
  { title: 'voluntary-change.steps.reissue', state: StepState.Normal }
]);

export const VoluntaryChangeFromManualFlowSteps = new ModuleSteps([
  {
    title: 'voluntary-change.steps.from-manual',
    state: StepState.Normal
  },
  { title: 'voluntary-change.steps.final', state: StepState.Normal },
  { title: 'voluntary-change.steps.reissue', state: StepState.Normal }
])
